function checkScrollbar() {
  //Get real width of page scroll-bar
  const w1 = document.documentElement.clientWidth;
  document.querySelector('html').classList.add('popup_lock');
  const w2 = document.documentElement.clientWidth;
  document.querySelector('html').classList.remove('popup_lock');
  return w2 - w1;
}


// FULL POPUP STUFF
function bodyStopScroll() {
  const scrollWidth = checkScrollbar();
  const stopScrollStyle = `
      <style id="scrollStuff">
        html {overflow: hidden;}
        body, .js_noscrol_pad { padding-right: ${scrollWidth}px; }
        body { width:auto; }
      </style>
    `;
  document.head.insertAdjacentHTML('beforeend', stopScrollStyle);
  document.body.classList.add('noscroll');
}
function bodyRemoveStopScroll() {
  if (document.head.querySelector('#scrollStuff')) {
    document.head.querySelector('#scrollStuff').remove();
  }
  document.body.classList.remove('noscroll');
}
// ==============






// let's get this party started
document.addEventListener('DOMContentLoaded', function () {



  // // phone mask
  // const phoneInputs = document.querySelectorAll('[type=tel]');

  // const prefixNumber = (str) => {
  //   if (str === '7') {
  //     return '7 ';
  //   }
  //   // if (str === "8") {
  //   //   return "8 ";
  //   // }
  //   // if (str === "9") {
  //   //   return "7 9";
  //   // }
  //   return `7 ${str}`;
  // };



  // phoneInputs.forEach(input => {
  //   input.addEventListener('input', (e) => {
  //     const value = input.value.replace(/\D+/g, '');
  //     const numberLength = 11;

  //     let result = '+';
  //     // if (input.value.includes('+8') || input.value[0] === '+7') {
  //     //   result = '';
  //     // } else {
  //     //   result = '+';
  //     // }

  //     //
  //     for (let i = 0; i < value.length && i < numberLength; i++) {
  //       switch (i) {
  //         case 0:
  //           result += prefixNumber(value[i]);
  //           continue;
  //         case 4:
  //           result += ' ';
  //           break;
  //         case 7:
  //           result += ' ';
  //           break;
  //         case 9:
  //           result += ' ';
  //           break;
  //         default:
  //           break;
  //       }
  //       result += value[i];
  //     }
  //     //
  //     input.value = result;
  //   });
  // });
  // // ======================================




  // textarea resize
  document.querySelectorAll('.js_textarea').forEach(trigger => {
    autosize(trigger);
  });
  // =====


  // SCROLL TO
  const scroller = new SweetScroll(
    {
      /* some options */
      trigger: '[data-scroll]',       // Selector for trigger (must be a valid css selector)
      header: '[data-scroll-header]', // Selector or Element for fixed header (Selector of must be a valid css selector)
      // header: '#header',
      duration: 500,                 // Specifies animation duration in integer
      easing: 'easeInOutSine',         // Specifies the pattern of easing
      offset: -50,                      // Specifies the value to offset the scroll position in pixels
      vertical: true,                 // Enable the vertical scroll
      horizontal: false,              // Enable the horizontal scroll
      cancellable: true,              // When fired wheel or touchstart events to stop scrolling
      updateURL: false,               // Update the URL hash on after scroll (true | false | 'push' | 'replace')
      preventDefault: true,           // Cancels the container element click event
      stopPropagation: true,          // Prevents further propagation of the container element click event in the bubbling phase

      // Callbacks
      // before: null,
      after: (offset, $trigger, scroller) => {
        // move focus to target
        let targetItem;
        if (!$trigger && offset.top === 0) {
          targetItem = document.body;
        } else if ($trigger && $trigger.getAttribute('href')) {
          targetItem = document.querySelector($trigger.getAttribute('href'));
        } else if ($trigger && $trigger.getAttribute('data-scroll').substring(0, 1) === '#') {
          targetItem = document.querySelector($trigger.getAttribute('data-scroll'));
        }
        if (targetItem) {
          targetItem.focus();
          if (targetItem !== document.activeElement) {
            targetItem.setAttribute('tabindex', '-1');
            targetItem.focus();
            targetItem.blur();
            targetItem.removeAttribute('tabindex');
          }
        }
      },
    },
  );
  document.querySelectorAll('[data-scroll-top]').forEach(item => {
    item.addEventListener('click', (e) => {
      e.preventDefault();
      scroller.toTop(0);
    });
  });
  //===============================



  // ACTIVE TOGGLE
  let toggleHold = false;
  document.querySelectorAll('.js_toggle_trigger').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!toggleHold) {
        toggleHold = true;
        let toggleTarget = ''
        if (trigger.getAttribute('data-target')) {
          toggleTarget = document.querySelector(trigger.getAttribute('data-target'))
        } else if (trigger.getAttribute('href')) {
          toggleTarget = document.querySelector(trigger.getAttribute('href'))
        } else {
          toggleTarget = trigger.closest('.js_toggle');
        }
        trigger.classList.toggle('m-active');
        toggleTarget.classList.toggle('m-active');

        setTimeout(() => {
          toggleHold = false;
        }, 500);
      }
    });
  });

  // ========================

  document.querySelectorAll('.js_burger_close').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      const burger = document.querySelector('.js_burger.m-active');
      if (burger) burger.click();
    });
  });



  // ==========================

  let stopscrollHold = false;
  document.querySelectorAll('.js_stopscroll').forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (!stopscrollHold) {
        stopscrollHold = true;
        if (!document.body.classList.contains('noscroll')) {
          bodyStopScroll();
        } else {
          setTimeout(() => {
            bodyRemoveStopScroll();
          }, 500);
        }
        setTimeout(() => {
          stopscrollHold = false;
        }, 500);
      }
    });
  });


  // ON HORIZONTAL RESIZE
  // - remove bodystopscroll
  let winWidth = window.innerWidth;
  let throttleresize;
  window.addEventListener('resize', function () {
    let newWinWidth = window.innerWidth;
    if (newWinWidth !== winWidth) {
      newWinWidth = newWinWidth;
      clearTimeout(throttleresize)
      throttleresize = setTimeout(function () {

        if (document.head.querySelector('#scrollStuff')) {
          bodyRemoveStopScroll();
        }

      }, 150)
    }
  }, false)





});


// =================================================
// =================================================
// =================================================

